"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboChartDescriptorDeprecated = void 0;
var tslib_1 = require("tslib");
var PluggableComboChartDeprecated_1 = require("./PluggableComboChartDeprecated");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var ComboChartDescriptorDeprecated = /** @class */ (function (_super) {
    tslib_1.__extends(ComboChartDescriptorDeprecated, _super);
    function ComboChartDescriptorDeprecated() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComboChartDescriptorDeprecated.prototype.getFactory = function () {
        return function (params) { return new PluggableComboChartDeprecated_1.PluggableComboChartDeprecated(params); };
    };
    return ComboChartDescriptorDeprecated;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.ComboChartDescriptorDeprecated = ComboChartDescriptorDeprecated;
//# sourceMappingURL=ComboChartDescriptorDeprecated.js.map